import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import Masonry from 'react-masonry-css';

import Lightbox from 'yet-another-react-lightbox';
// eslint-disable-next-line import/no-unresolved
import Zoom from 'yet-another-react-lightbox/plugins/zoom';

import useActivePortfolio from '../configs/useActivePortfolio';
import useSeoMetadata from '../configs/useSeoMetadata';

import NavbarCustom from '../components/NavbarCustom';
import FooterOne from '../components/FooterOne';

import '../styles/_ecommerce.scss';

export default function Ecommerce() {

    const { lng } = useParams();

    const { i18n, t } = useTranslation();
    const activePortfolio = useActivePortfolio(lng || i18n.language);
    const { ecommerceGallery } = activePortfolio;

    useSeoMetadata(activePortfolio.seo);

    useEffect(() => {

        if (lng && i18n.language !== lng) {

            i18n.changeLanguage(lng);
        }

    }, [lng, i18n]);

    const [open, setOpen] = useState(false);

    const [index, setIndex] = useState(0);

    const breakpointColumnsObj = {
        default: 2,
        1200: 2,
        992: 2,
        576: 1,
    };

    const slides = ecommerceGallery
        .filter((item) => item.type === 'image')
        .map((item) => ({
            src: item.src,
        }));

    return (

        <>

            <header>
                <NavbarCustom linksDisabled homeLink={`/${lng || i18n.language}`} />
            </header>

            <section className="ecommerce-page">

            <div className="container">

                <div className="ecommerce-page__hero">

                    <span className="ecommerce-page__badge">
                        {t('commercialFrontend')}
                    </span>

                    <h1 className="ecommerce-page__title">
                        {t('ecommerceTitle')}
                    </h1>

                    <p className="ecommerce-page__description">
                        {t('ecommerceDescription')}
                    </p>

                </div>

                <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-grid__column"
                >

                    {

                        ecommerceGallery.map((item, itemIndex) => (

                            <button
                                type="button"
                                key={item.id}
                                className="gallery-card"
                                onClick={() => {
                                    setIndex(itemIndex);
                                    setOpen(true);
                                }}
                            >

                                <div className="gallery-card__image-wrapper">

                                    {

                                        item.type === 'video' ? (

                                            <video
                                                className="gallery-card__image"
                                                src={item.src}
                                                muted
                                                loop
                                                autoPlay
                                                playsInline
                                            />

                                        ) : (

                                            <img
                                                loading="lazy"
                                                src={item.src}
                                                alt={item.title}
                                                className="gallery-card__image"
                                            />

                                        )

                                    }

                                </div>

                                <div className="gallery-card__content">

                                    <span className="gallery-card__brand">
                                        {item.brand}
                                    </span>

                                    <h2 className="gallery-card__title">
                                        {item.title}
                                    </h2>

                                    

                                    <div className="gallery-card__tags">

                                        {

                                            item.stack.map((tech) => (

                                                <span
                                                    key={tech}
                                                    className="gallery-card__tag"
                                                >
                                                    {tech}
                                                </span>

                                            ))

                                        }

                                    </div>

                                </div>

                            </button>

                        ))

                    }

                </Masonry>

            </div>

            <Lightbox
                open={open}
                close={() => setOpen(false)}
                index={index}
                slides={slides}
                plugins={[Zoom]}
                zoom={{ maxZoomPixelRatio: 3 }}
                carousel={{ finite: true }}
                controller={{ closeOnBackdropClick: true }}
                styles={{
                    container: {
                        backgroundColor: 'rgba(0,0,0,.95)',
                    },
                }}
            />

        </section>

        <div id="contacto"><FooterOne /></div>

        </>

    );
}
